import { render } from "./SusProduction.vue?vue&type=template&id=39f06c34&scoped=true"
import script from "./SusProduction.vue?vue&type=script&lang=js"
export * from "./SusProduction.vue?vue&type=script&lang=js"

import "./SusProduction.vue?vue&type=style&index=0&id=39f06c34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f06c34"]])

export default __exports__